export default __webpack_public_path__ + "static/media/touch-of-grey-logo.5f88d69e.png";